import 'core-js/modules/es7.array.includes';
import 'core-js/modules/es6.string.includes';
import 'core-js/modules/es6.object.keys';
import 'core-js/modules/es6.function.name';
import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/web.dom.iterable';
import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/es6.array.from';
import _classCallCheck from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _possibleConstructorReturn from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
import _createClass from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _inherits from '/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/imageupload/imageuploadediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import Notification from '@ckeditor/ckeditor5-ui/src/notification/notification';
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard';
import UpcastWriter from '@ckeditor/ckeditor5-engine/src/view/upcastwriter';
import env from '@ckeditor/ckeditor5-utils/src/env';
import ImageUploadCommand from '../../src/imageupload/imageuploadcommand';
import {
    fetchLocalImage,
    isLocalImage
} from '../../src/imageupload/utils';
import { createImageTypeRegExp } from './utils';
/**
 * The editing part of the image upload feature. It registers the `'imageUpload'` command.
 *
 * @extends module:core/plugin~Plugin
 */
var ImageUploadEditing = /*#__PURE__*/
function (_Plugin) {
    _inherits(ImageUploadEditing, _Plugin);
    _createClass(ImageUploadEditing, null, [
        {
            key: 'requires',
            /**
     * @inheritDoc
     */
            get: function get() {
                return [
                    FileRepository,
                    Notification,
                    Clipboard
                ];
            }
        },
        {
            key: 'pluginName',
            get: function get() {
                return 'ImageUploadEditing';
            }    /**
     * @inheritDoc
     */
        }
    ]);
    function ImageUploadEditing(editor) {
        var _this;
        _classCallCheck(this, ImageUploadEditing);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageUploadEditing).call(this, editor));
        editor.config.define('image', {
            upload: {
                types: [
                    'jpeg',
                    'png',
                    'gif',
                    'bmp',
                    'webp',
                    'tiff'
                ]
            }
        });
        return _this;
    }
    /**
   * @inheritDoc
   */
    _createClass(ImageUploadEditing, [
        {
            key: 'init',
            value: function init() {
                var _this2 = this;
                var editor = this.editor;
                var doc = editor.model.document;
                var schema = editor.model.schema;
                var conversion = editor.conversion;
                var fileRepository = editor.plugins.get(FileRepository);
                var imageTypes = createImageTypeRegExp(editor.config.get('image.upload.types'));
                // Setup schema to allow uploadId and uploadStatus for images.
                schema.extend('image', {
                    allowAttributes: [
                        'uploadId',
                        'uploadStatus'
                    ]
                });
                // Register imageUpload command.
                editor.commands.add('imageUpload', new ImageUploadCommand(editor));
                // Register upcast converter for uploadId.
                conversion.for('upcast').attributeToAttribute({
                    view: {
                        name: 'img',
                        key: 'uploadId'
                    },
                    model: 'uploadId'
                });
                // Handle pasted images.
                // For every image file, a new file loader is created and a placeholder image is
                // inserted into the content. Then, those images are uploaded once they appear in the model
                // (see Document#change listener below).
                this.listenTo(editor.editing.view.document, 'clipboardInput', function (evt, data) {
                    // Skip if non empty HTML data is included.
                    // https://github.com/ckeditor/ckeditor5-upload/issues/68
                    if (isHtmlIncluded(data.dataTransfer)) {
                        return;
                    }
                    var images = Array.from(data.dataTransfer.files).filter(function (file) {
                        // See https://github.com/ckeditor/ckeditor5-image/pull/254.
                        if (!file) {
                            return false;
                        }
                        return imageTypes.test(file.type);
                    });
                    var ranges = data.targetRanges.map(function (viewRange) {
                        return editor.editing.mapper.toModelRange(viewRange);
                    });
                    editor.model.change(function (writer) {
                        // Set selection to paste target.
                        writer.setSelection(ranges);
                        if (images.length) {
                            evt.stop();
                            // Upload images after the selection has changed in order to ensure the command's state is refreshed.
                            editor.model.enqueueChange('default', function () {
                                editor.execute('imageUpload', { file: images });
                            });
                        }
                    });
                });
                // Handle HTML pasted with images with base64 or blob sources.
                // For every image file, a new file loader is created and a placeholder image is
                // inserted into the content. Then, those images are uploaded once they appear in the model
                // (see Document#change listener below).
                this.listenTo(editor.plugins.get(Clipboard), 'inputTransformation', function (evt, data) {
                    var fetchableImages = Array.from(editor.editing.view.createRangeIn(data.content)).filter(function (value) {
                        return isLocalImage(value.item) && !value.item.getAttribute('uploadProcessed');
                    }).map(function (value) {
                        return {
                            promise: fetchLocalImage(value.item),
                            imageElement: value.item
                        };
                    });
                    if (!fetchableImages.length) {
                        return;
                    }
                    var writer = new UpcastWriter();
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for (var _iterator = fetchableImages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var fetchableImage = _step.value;
                            // Set attribute marking that the image was processed already.
                            writer.setAttribute('uploadProcessed', true, fetchableImage.imageElement);
                            var loader = fileRepository.createLoader(fetchableImage.promise);
                            if (loader) {
                                writer.setAttribute('src', '', fetchableImage.imageElement);
                                writer.setAttribute('uploadId', loader.id, fetchableImage.imageElement);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
                // Prevents from the browser redirecting to the dropped image.
                editor.editing.view.document.on('dragover', function (evt, data) {
                    data.preventDefault();
                });
                // Upload placeholder images that appeared in the model.
                doc.on('change', function () {
                    var changes = doc.differ.getChanges({ includeChangesInGraveyard: true });
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;
                    try {
                        for (var _iterator2 = changes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var entry = _step2.value;
                            if (entry.type == 'insert' && entry.name != '$text') {
                                var item = entry.position.nodeAfter;
                                var isInGraveyard = entry.position.root.rootName == '$graveyard';
                                var _iteratorNormalCompletion3 = true;
                                var _didIteratorError3 = false;
                                var _iteratorError3 = undefined;
                                try {
                                    for (var _iterator3 = getImagesFromChangeItem(editor, item)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                        var image = _step3.value;
                                        // Check if the image element still has upload id.
                                        var uploadId = image.getAttribute('uploadId');
                                        if (!uploadId) {
                                            continue;
                                        }
                                        // Check if the image is loaded on this client.
                                        var loader = fileRepository.loaders.get(uploadId);
                                        if (!loader) {
                                            continue;
                                        }
                                        if (isInGraveyard) {
                                            // If the image was inserted to the graveyard - abort the loading process.
                                            loader.abort();
                                        } else if (loader.status == 'idle') {
                                            // If the image was inserted into content and has not been loaded yet, start loading it.
                                            _this2._readAndUpload(loader, image);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                            _iterator3.return();
                                        }
                                    } finally {
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                });
            }    /**
     * Reads and uploads an image.
     *
     * The image is read from the disk and as a Base64-encoded string it is set temporarily to
     * `image[src]`. When the image is successfully uploaded, the temporary data is replaced with the target
     * image's URL (the URL to the uploaded image on the server).
     *
     * @protected
     * @param {module:upload/filerepository~FileLoader} loader
     * @param {module:engine/model/element~Element} imageElement
     * @returns {Promise}
     */
        },
        {
            key: '_readAndUpload',
            value: function _readAndUpload(loader, imageElement) {
                var _this3 = this;
                var editor = this.editor;
                var model = editor.model;
                var t = editor.locale.t;
                var fileRepository = editor.plugins.get(FileRepository);
                var notification = editor.plugins.get(Notification);
                model.enqueueChange('transparent', function (writer) {
                    writer.setAttribute('uploadStatus', 'reading', imageElement);
                });
                return loader.read().then(function () {
                    var promise = loader.upload();
                    // Force re–paint in Safari. Without it, the image will display with a wrong size.
                    // https://github.com/ckeditor/ckeditor5/issues/1975
                    /* istanbul ignore next */
                    if (env.isSafari) {
                        var viewFigure = editor.editing.mapper.toViewElement(imageElement);
                        var viewImg = viewFigure.getChild(0);
                        editor.editing.view.once('render', function () {
                            // Early returns just to be safe. There might be some code ran
                            // in between the outer scope and this callback.
                            if (!viewImg.parent) {
                                return;
                            }
                            var domFigure = editor.editing.view.domConverter.mapViewToDom(viewImg.parent);
                            if (!domFigure) {
                                return;
                            }
                            var originalDisplay = domFigure.style.display;
                            domFigure.style.display = 'none';
                            // Make sure this line will never be removed during minification for having "no effect".
                            domFigure._ckHack = domFigure.offsetHeight;
                            domFigure.style.display = originalDisplay;
                        });
                    }
                    model.enqueueChange('transparent', function (writer) {
                        writer.setAttribute('uploadStatus', 'uploading', imageElement);
                    });
                    return promise;
                }).then(function (data) {
                    model.enqueueChange('transparent', function (writer) {
                        writer.setAttributes({
                            uploadStatus: 'complete',
                            src: data.default
                        }, imageElement);
                        _this3._parseAndSetSrcsetAttributeOnImage(data, imageElement, writer);
                    });
                    clean();
                }).catch(function (error) {
                    // If status is not 'error' nor 'aborted' - throw error because it means that something else went wrong,
                    // it might be generic error and it would be real pain to find what is going on.
                    if (loader.status !== 'error' && loader.status !== 'aborted') {
                        throw error;
                    }
                    // Might be 'aborted'.
                    if (loader.status == 'error' && error) {
                        notification.showWarning(error, {
                            title: t('Upload failed'),
                            namespace: 'upload'
                        });
                    }
                    clean();
                    // Permanently remove image from insertion batch.
                    model.enqueueChange('transparent', function (writer) {
                        writer.remove(imageElement);
                    });
                });
                function clean() {
                    model.enqueueChange('transparent', function (writer) {
                        writer.removeAttribute('uploadId', imageElement);
                        writer.removeAttribute('uploadStatus', imageElement);
                    });
                    fileRepository.destroyLoader(loader);
                }
            }    /**
     * Creates the `srcset` attribute based on a given file upload response and sets it as an attribute to a specific image element.
     *
     * @protected
     * @param {Object} data Data object from which `srcset` will be created.
     * @param {module:engine/model/element~Element} image The image element on which the `srcset` attribute will be set.
     * @param {module:engine/model/writer~Writer} writer
     */
        },
        {
            key: '_parseAndSetSrcsetAttributeOnImage',
            value: function _parseAndSetSrcsetAttributeOnImage(data, image, writer) {
                // Srcset attribute for responsive images support.
                var maxWidth = 0;
                var srcsetAttribute = Object.keys(data)    // Filter out keys that are not integers.
.filter(function (key) {
                    var width = parseInt(key, 10);
                    if (!isNaN(width)) {
                        maxWidth = Math.max(maxWidth, width);
                        return true;
                    }
                })    // Convert each key to srcset entry.
.map(function (key) {
                    return ''.concat(data[key], ' ').concat(key, 'w');
                })    // Join all entries.
.join(', ');
                if (srcsetAttribute != '') {
                    writer.setAttribute('srcset', {
                        data: srcsetAttribute,
                        width: maxWidth
                    }, image);
                }
            }
        }
    ]);
    return ImageUploadEditing;
}(Plugin);
// Returns `true` if non-empty `text/html` is included in the data transfer.
//
// @param {module:clipboard/datatransfer~DataTransfer} dataTransfer
// @returns {Boolean}
export {
    ImageUploadEditing as default
};
export function isHtmlIncluded(dataTransfer) {
    return Array.from(dataTransfer.types).includes('text/html') && dataTransfer.getData('text/html') !== '';
}
function getImagesFromChangeItem(editor, item) {
    return Array.from(editor.model.createRangeOn(item)).filter(function (value) {
        return value.item.is('image');
    }).map(function (value) {
        return value.item;
    });
}